<template>
  <div>
    <el-divider>{{$t('私有属性')}}</el-divider>
    <el-form-item :label="$t('描述文案')">
        <el-input v-model="data.txt" :placeholder="$t('请输入描述文案')"></el-input>
    </el-form-item>
    <el-form-item :label="$t('CSS配置')">
        <el-input v-model="data.css" :rows="6" type="textarea" :placeholder="$t('请输入cssJSON配置')"></el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
    name: "config-txt",
    props: ['data'],
    data () {
        return{}
    },
    methods: {
       
    }
}
</script>

